import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ADD_TEST, ALL_CATEGORIES, ALL_TEST, BASE_URL, DELETE_TEST, SINGLE_TEST, UPDATE_TEST } from 'src/app/endpoints';

@Injectable({
  providedIn: 'root'
})
export class LabTestService {

  constructor(private http:HttpClient) { }

  allTests(data: any) {
      return this.http.post<any>(BASE_URL + ALL_TEST, data)
    }
    
   addTest(data: any) {
        return this.http.post<any>(BASE_URL + ADD_TEST, data)
      }

      updateTest(data: any) {
  return this.http.post<any>(BASE_URL + UPDATE_TEST, data);
}
      deleteTest(id: string) {
  return this.http.post<any>(BASE_URL + DELETE_TEST, {_id: id});
}

getSingleTest(id: string) {
  return this.http.post<any>(BASE_URL + SINGLE_TEST, { _id: id });
}

}
